<template>
    <v-layout justify-center>
        <v-responsive max-width="1600" width="100%" height="100%" class="mx-n3 px-3">
            <list-heading title="예약 목록">
                <template #add-button>
                    <rental-request-view>
                        <template #activator="{ attrs, on }">
                            <v-btn text icon tile color="primary" title="예약 생성" v-bind="attrs" v-on="on"> <v-icon>mdi-plus</v-icon> </v-btn>
                        </template>
                    </rental-request-view>
                </template>
            </list-heading>

            <schedule-list-filter />

            <v-card outlined class="mt-4" style="overflow: hidden">
                <v-data-table v-bind="{ headers, items }" disable-sort disable-pagination hide-default-footer :items-per-page="-1">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                    <template #[`item.state`]="{ item, value }">
                        <v-edit-dialog :return-value.sync="item.state" large cancel-text="취소" save-text="변경" @open="state = value" @save="putStateOf(item)">
                            {{ RENTAL_SCHEDULE_STATES[value]?.text }}
                            <template #input> <v-select v-model="state" :items="Object.values(RENTAL_SCHEDULE_STATES)" v-bind="attrs_input" class="mt-3" /> </template>
                        </v-edit-dialog>
                    </template>
                </v-data-table>
            </v-card>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input, RENTAL_SCHEDULE_STATES } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import RentalRequestView from "@/components/console/rental/rental-request-view.vue";
import ScheduleListFilter from "@/components/console/rental/schedule-list-filter.vue";

const defaultFormatter = (value) => value || "-";
const headers = [
    { width: +80, align: "right", text: "#", value: "index" },
    { width: 170, align: "center", text: "신청일", value: "createdAt", formatter: (value) => value?.toDateTime?.(), divider: true },
    { width: +80, align: "center", text: "장소", value: "subject.location" },
    { width: 140, align: "center", text: "설비명", value: "subject.name", divider: true },
    { width: 120, align: "center", text: "예약일", value: "date", formatter: (value) => value?.toDate?.() },
    { width: 270, align: "left", text: "예약시간", value: "times", formatter: (value) => (value?.length ? value.map((time) => `${time}시`).join(", ") : "종일"), divider: true },
    { width: 210, align: "center", text: "목적", value: "usage", divider: true },
    { width: 120, align: "center", text: "아이디", value: "user.username" },
    { width: 120, align: "center", text: "이름", value: "user.name" },
    { width: 140, align: "center", text: "전화번호", value: "user.phone", divider: true },
    { width: 120, align: "center", text: "상태", value: "state" },
].map((item) => ({ ...item, formatter: item?.formatter || defaultFormatter }));

export default {
    components: {
        ListHeading,
        RentalRequestView,
        ScheduleListFilter,
    },
    data() {
        return {
            requests: [],
            state: RENTAL_SCHEDULE_STATES.APPLIED.value,

            limit: 10,
            summary: { totalCount: 0 },

            headers,
            attrs_input,
            RENTAL_SCHEDULE_STATES,
        };
    },
    computed: {
        items() {
            return this.requests.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { query } = this.$route;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            try {
                let { skip, limit, params } = this;
                var { summary, requests } = await api.console.rental.requests.gets({
                    headers: { skip, limit },
                    params,
                });

                this.requests = requests;
                this.summary = summary;
            } catch (error) {
                console.error(error);
            }
        },

        async putStateOf(request) {
            let go = confirm("해당 예약의 상태를 변경하시겠습니까?");
            if (go) {
                let { state } = this;
                let { _id, schedules = [] } = request || {};
                schedules = await Promise.all(
                    schedules.map(async (schedule = {}) => {
                        let { _id } = schedule;
                        try {
                            return { ...((await api.console.rental.schedules.put({ _id, state }))?.schedule || schedule), success: true };
                        } catch (error) {
                            console.error(error);
                            return { ...schedule, success: false };
                        }
                    })
                );
                let failedItemsLength = schedules.filter(({ success }) => !success)?.length;
                if (failedItemsLength) {
                    alert(`총 ${schedules.length} 건 예약시간 중 ${failedItemsLength} 건의 상태 변경에 실패하였습니다.`);
                } else {
                    alert("모든 예약시간 상태 변경이 성공하였습니다.");
                }

                let { schedule } = await api.console.rental.requests.put({ _id, state });
                this.update(schedule);
            }
        },

        async update(item) {
            const index = this.requests.findIndex(({ _id }) => _id == item._id);
            this.requests.splice(index, 1, item);
            if (index == -1) this.search();
            else this.requests.splice(index, 1, item);
        },
    },
};
</script>
